import { useState } from "react";
import Constantes from "../../constantes";
import MiniMapa from "../../componentes/MiniMapa";
import { useNavigate } from "react-router-dom";
function SubirContenido() {
  const navigate = useNavigate();
  const [texto, setTexto] = useState("");
  const maxChars = 255;

  const hoy = new Date();
  const offset = hoy.getTimezoneOffset();
  const horaLocal = new Date(hoy.getTime() - offset * 60 * 1000);
  const fechaISO = horaLocal.toISOString().slice(0, 16);

  const [fechaPublicacion, setFechaPublicacion] = useState("");
  const [fechaCaducidad, setFechaCaducidad] = useState("");

  const [delay, setDelayed] = useState(false);
  const [caducidad, setCaducidad] = useState(false);
  const [publico, setPublico] = useState(false);

  const [imagenes, setImagenes] = useState([]);

  const [ubicacion, setUbicacion] = useState(null);
  const [cargandoUbicacion, setCargandoUbicacion] = useState(false);

  const handleImagenesChange = (e) => {
    const files = Array.from(e.target.files);
    if (files.length + imagenes.length > 5) {
      alert("Solo puedes subir un máximo de 5 imágenes.");
      return;
    }
    setImagenes((prevImagenes) => [...prevImagenes, ...files]);
  };

  const handleChange = (e) => {
    setTexto(e.target.value);
  };
  const handleDelay = (e) => {
    const check = e.target.checked;
    setDelayed(check);
    if (!check) {
      setFechaPublicacion("");
    }
  };
  const handleCaducidad = (e) => {
    const check = e.target.checked;
    setCaducidad(check);
    if (!check) {
      setFechaCaducidad("");
    }
  };

  const handlePublico = (e) => {
    setPublico(e.target.checked);
  };

  const handleEliminarImagen = (index) => {
    setImagenes((prevImagenes) => prevImagenes.filter((_, i) => i !== index));
  };

  const procesarPeticion = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();
      formData.append("texto", texto);
      formData.append("delay", delay ? 1 : 0);
      formData.append("caducidad", caducidad ? 1 : 0);
      formData.append("publico", publico ? 1 : 0);

      //pasamos a utc 0

      const toUTC = (fechaLocal) => {
        if (!fechaLocal) return null;
        return new Date(fechaLocal)
          .toISOString()
          .slice(0, 19)
          .replace("T", " ");
      };

      if (delay && fechaPublicacion) {
        formData.append("fechaPublicacion", toUTC(fechaPublicacion));
      } else {
        formData.append("fechaPublicacion", toUTC(fechaISO));
      }

      if (caducidad && fechaCaducidad) {
        formData.append("fechaCaducidad", toUTC(fechaCaducidad));
      }

      if (ubicacion) {
        formData.append("latitud", ubicacion.lat);
        formData.append("longitud", ubicacion.lon);
      }

      imagenes.forEach((imagen) => {
        formData.append("files", imagen);
      });

      const respuesta = await fetch(
        Constantes.RUTA_API + "/publicaciones/crearPublicacion",
        { method: "POST", credentials: "include", body: formData },
      );

      const data = await respuesta.json();
      alert(data.message);

      if (respuesta.ok) {
        navigate("/", { replace: true });
      }
    } catch (error) {
      console.error("Error al enviar:", error);
      alert("Hubo un error al enviar el formulario");
    }
  };

  const fechaPubInvalida =
    delay && (!fechaPublicacion || fechaPublicacion < fechaISO);

  const fechaCadInvalida =
    caducidad &&
    (!fechaCaducidad ||
      fechaCaducidad <= (fechaPublicacion ? fechaPublicacion : fechaISO));

  const formularioInvalido =
    fechaPubInvalida || fechaCadInvalida || texto.trim() === "";

  return (
    <>
      <div className="App d-flex bg-dark text-white">
        <form
          onSubmit={procesarPeticion}
          style={{ display: "flex", width: "100%", flexWrap: "wrap" }}
        >
          <div
            className="col-md-3 col-12 paddingLess"
            style={{
              display: "flex",
              flexDirection: "column",
              boxSizing: "border-box",
            }}
          >
            <div
              style={{
                backgroundColor: "black",
                overflowY: "auto",
                boxSizing: "border-box",
              }}
            >
              <h5 style={{ padding: "20px", margin: 0 }}>Opciones</h5>

              <div style={{ padding: "0 20px" }}>
                <div className="form-check mb-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={delay}
                    onChange={handleDelay}
                  />
                  <label>¿Quieres retrasar la publicación?</label>
                </div>

                {delay && (
                  <div className="mb-4">
                    <label className="form-label">Fecha de publicación:</label>
                    <input
                      className="form-control"
                      type="datetime-local"
                      min={fechaISO}
                      value={fechaPublicacion}
                      onChange={(e) => setFechaPublicacion(e.target.value)}
                    />
                    {fechaPubInvalida && (
                      <small className="text-danger">Fecha inválida</small>
                    )}
                  </div>
                )}

                <div className="form-check mb-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={caducidad}
                    onChange={handleCaducidad}
                  />
                  <label>¿Caduca automáticamente?</label>
                </div>

                {caducidad && (
                  <div className="mb-4">
                    <label className="form-label">Fecha de expiración:</label>
                    <input
                      className="form-control"
                      type="datetime-local"
                      min={fechaPublicacion || fechaISO}
                      value={fechaCaducidad}
                      onChange={(e) => setFechaCaducidad(e.target.value)}
                    />
                    {fechaCadInvalida && (
                      <small className="text-danger">Fecha inválida</small>
                    )}
                  </div>
                )}

                <div className="form-check mb-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={publico}
                    onChange={handlePublico}
                  />
                  <label>¿Publicación pública?</label>
                </div>
              </div>
            </div>
          </div>

          <div
            className="col-md-9 col-12 paddingLess"
            style={{
              display: "flex",
              flexDirection: "column",
              boxSizing: "border-box",
              padding: "20px",
            }}
          >
            <h5 style={{ padding: "10px 20px", margin: 0 }}>Publicación</h5>

            <div style={{ padding: "0 20px" }}>
              <label className="form-label">Texto:</label>

              <textarea
                className="form-control"
                value={texto}
                onChange={handleChange}
                maxLength={maxChars}
                rows="5"
              />

              <div style={{ textAlign: "right", fontSize: "0.8rem" }}>
                {texto.length}/{maxChars}
              </div>
            </div>

            <div style={{ padding: "20px" }}>
              <input
                type="file"
                multiple
                accept="image/*"
                onChange={handleImagenesChange}
                className="form-control"
              />

              {imagenes.length > 0 && (
                <div className="d-flex flex-wrap gap-2 mt-3">
                  {imagenes.map((img, i) => (
                    <div key={i} style={{ width: "100px", height: "100px" }}>
                      <img
                        src={URL.createObjectURL(img)}
                        alt={`imagen-${i}`}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                      <button
                        type="button"
                        onClick={() => handleEliminarImagen(i)}
                        className="btn btn-danger btn-sm w-100"
                      >
                        Eliminar
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div style={{ padding: "20px" }}>
              <button
                type="button"
                className="btn btn-outline-info"
                onClick={() => {
                  setCargandoUbicacion(true);

                  navigator.geolocation.getCurrentPosition(
                    (pos) => {
                      setUbicacion({
                        lat: pos.coords.latitude,
                        lon: pos.coords.longitude,
                      });
                      setCargandoUbicacion(false);
                    },
                    () => {
                      alert("No se pudo obtener la ubicación.");
                      setCargandoUbicacion(false);
                    },
                  );
                }}
                disabled={cargandoUbicacion}
              >
                {cargandoUbicacion
                  ? "Obteniendo ubicación..."
                  : "Usar ubicación actual"}
              </button>

              {ubicacion && (
                <>
                  <MiniMapa lat={ubicacion.lat} lon={ubicacion.lon} />
                  <button
                    type="button"
                    className="btn btn-danger mt-2"
                    onClick={() => setUbicacion(null)}
                  >
                    Quitar ubicación
                  </button>
                </>
              )}
            </div>

            <button
              type="submit"
              className="btn btn-primary mx-3"
              disabled={formularioInvalido}
            >
              Publicar
            </button>
          </div>
        </form>
      </div>

      <title>Subir publicación</title>
    </>
  );
}

export default SubirContenido;
